import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";

export const userService = {
  authenticate: async (email, password, role) => {
    const url = `${API_ENDPOINT.USER_AUTHENTICATION.LOGIN}?timestamp=${Date.now()}`;

    try {
      const response = await axios.post(url, {
        email,
        password,
        loginType: role.toUpperCase(),
      });
      return response.data;
    } catch (error) {
      console.error("Login API Error:", error);
      throw error.response?.data || { message: "Network error" };
    }
  },
};
